import {
    modelGet as modelGetWrapper,
    modelPost as modelPostWrapper,
    modelActionCall as modelActionCallWrapper
} from 'pluton-core/lib/actions/model.actions';
import { history } from '../entry/history';
import { getCallbackErrors } from './common.actions';


export const modelGet = (model, customMethod = null) => {
    return modelGetWrapper(model, history, getCallbackErrors(), customMethod)
};

export const modelPost = (model) => {
    return modelPostWrapper(model, history, getCallbackErrors())
};

export const modelActionCall = (model, actionName, requestMethodName = 'GET') => {
    return modelActionCallWrapper(model, history, getCallbackErrors(), requestMethodName, actionName)
};




// WEBPACK FOOTER //
// ./app/actions/model.actions.js